<div class="coming-soon-container">
  <div class="coming-soon-content">
    <div class="icon-container">
      <mat-icon class="coming-soon-icon">{{icon}}</mat-icon>
    </div>
    
    <div class="message-container">
      <h1 class="coming-soon-title">{{title}}</h1>
      <p class="coming-soon-message">{{message}}</p>
    </div>
    
    <div class="action-container" *ngIf="showContactButton">
      <button mat-raised-button 
              color="primary" 
              class="contact-button"
              (click)="onContactTeam()">
        <mat-icon>support_agent</mat-icon>
        {{contactText}}
      </button>
    </div>
  </div>
</div>